import { render } from "./AppRichiestaProva.vue?vue&type=template&id=8a96769a&scoped=true"
import script from "./AppRichiestaProva.vue?vue&type=script&lang=js"
export * from "./AppRichiestaProva.vue?vue&type=script&lang=js"

import "./AppRichiestaProva.vue?vue&type=style&index=0&id=8a96769a&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a96769a"]])

export default __exports__